function TableDetails({ orders, onOrderClick, title }) {
    if (!orders) {
      return null;
    }
  
    return (
      <>
        <h2 className='info-heading'>{title}</h2>
        <table className='order-table'>
          <thead>
            <tr>
              <th>ID</th>
              <th>Vārds</th>
              <th>Datums</th>
              <th>Summa</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.response_data.id} onClick={() => onOrderClick(order)}>
                <td>{order.response_data.id}</td>
                <td>{order.response_data.billing.first_name}</td>
                <td>{order.response_data.date_created.split('T')[0]}</td>
                <td>€{order.response_data.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    )
  }
  
  export default TableDetails